import IncomeAndProfitGraph from './IncomeAndProfitGraph';
import BuyReportWrapper from '../components/BuyReportWrapper';

const FinancialData = ({ handleBuyReport }) => {
  return (
    <BuyReportWrapper type="financialData" handleBuyReport={handleBuyReport}>
      <IncomeAndProfitGraph />
    </BuyReportWrapper>
  );
};

export default FinancialData;
